export default {
  page_title: 'ตั้งค่าวิดเจ็ตผู้มาเยือน',
  widget: {
    enabled_label: 'เปิดใช้งาน',
    embed_link_label: 'ลิงก์ฝัง (iframe)',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    no_key_yet: 'ยังไม่ได้ออกรหัส',
    public_key_label: 'รหัสสาธารณะ',
    generate_key: 'ออกรหัส',
    rotate_key: 'หมุนรหัสใหม่',
    rotate_confirm_title: 'หมุนรหัสสาธารณะใหม่หรือไม่?',
    rotate_confirm_message:
      'การหมุนรหัสจะออกรหัสใหม่ทันทีและทำให้รหัสเดิมใช้ไม่ได้ iframe ที่ฝังไว้บนเว็บไซต์ของคุณด้วยรหัสเดิมจะหยุดทำงานจนกว่าคุณจะอัปเดตลิงก์ใหม่',
    create_title: 'ยังไม่มีวิดเจ็ตผู้มาเยือน',
    create_description: 'สร้างวิดเจ็ตผู้มาเยือนสำหรับอาคารนี้เพื่อรับฟอร์มลงทะเบียนที่ฝังได้และรหัสสาธารณะ',
    create_action: 'สร้างวิดเจ็ต',
  },
  availability: {
    weekday: {
      mon: 'จันทร์',
      tue: 'อังคาร',
      wed: 'พุธ',
      thu: 'พฤหัสบดี',
      fri: 'ศุกร์',
      sat: 'เสาร์',
      sun: 'อาทิตย์',
    },
    closed: 'ปิด',
    open_today: 'เปิดวันนี้',
    add_window: 'เพิ่มช่วงเวลา',
    remove_window: 'ลบช่วงเวลา',
    window_from: 'เวลาเริ่ม',
    window_to: 'เวลาสิ้นสุด',
    validation_incomplete: 'กรุณาระบุเวลาเริ่มและเวลาสิ้นสุดให้ครบทุกช่วงเวลา',
    validation_order: 'เวลาเริ่มต้องมาก่อนเวลาสิ้นสุดในทุกช่วงเวลา',
    validation_overlap: 'ช่วงเวลาภายในวันเดียวกันต้องไม่ทับซ้อนกัน',
  },
  settings: {
    slot_minutes_label: 'ความยาวช่อง (นาที)',
    lead_time_minutes_label: 'เวลาเตรียมล่วงหน้า (นาที)',
    max_per_slot_label: 'คนต่อช่อง',
    booking_window_days_label: 'จองล่วงหน้าได้ (วัน)',
  },
  messages: {
    widget_created: 'สร้างวิดเจ็ตผู้มาเยือนแล้ว',
    create_error: 'ไม่สามารถสร้างวิดเจ็ตผู้มาเยือนได้',
    settings_saved: 'บันทึกการตั้งค่าแล้ว',
    save_error: 'ไม่สามารถบันทึกการตั้งค่าได้',
    key_rotated: 'หมุนรหัสสาธารณะแล้ว',
    rotate_error: 'ไม่สามารถหมุนรหัสสาธารณะได้',
    enabled_on: 'เปิดใช้งานวิดเจ็ตแล้ว',
    enabled_off: 'ปิดใช้งานวิดเจ็ตแล้ว',
    toggle_error: 'ไม่สามารถอัปเดตวิดเจ็ตได้',
  },
  iframe: {
    kicker: 'ลงทะเบียนผู้มาเยือน',
    tagline: 'ลงทะเบียนล่วงหน้าเพื่อให้เจ้าหน้าที่จัดเตรียมบัตรให้พร้อม',
    not_found_title: 'Widget ไม่พร้อมใช้งาน',
    not_found_message:
      'หน้าลงทะเบียนผู้มาเยือนนี้ไม่พร้อมใช้งานแล้ว กรุณาติดต่อที่พักโดยตรง',
    pick_date_title: 'เลือกวันและเวลา',
    date_label: 'วันที่',
    no_slots: 'ไม่มีช่วงเวลาว่างในวันนี้',
    availability_error: 'ไม่สามารถโหลดช่วงเวลาว่างได้ กรุณาลองอีกครั้ง',
    back: 'กลับ',
    details_title: 'ข้อมูลของคุณ',
    first_name: 'ชื่อ',
    last_name: 'นามสกุล',
    phone: 'เบอร์โทรศัพท์',
    send_otp: 'ส่งรหัสยืนยัน',
    invalid_phone: 'กรุณากรอกเบอร์มือถือไทยที่ถูกต้อง (เช่น 0812345678)',
    send_error: 'ไม่สามารถส่งรหัสได้ กรุณาลองอีกครั้งในอีกสักครู่',
    otp_title: 'กรอกรหัสยืนยัน',
    otp_hint: 'เราได้ส่งรหัส 6 หลักไปยังเบอร์โทรศัพท์ของคุณ',
    otp_code: 'รหัสยืนยัน',
    verify: 'ยืนยัน',
    invalid_otp: 'รหัสไม่ถูกต้อง กรุณาลองอีกครั้ง',
    consent_title: 'ยืนยันการเข้าเยี่ยมชม',
    consent_checkbox:
      'ฉันยินยอมให้ที่พักเก็บรวบรวมและใช้ชื่อและเบอร์โทรศัพท์ของฉันเพื่อการเข้าเยี่ยมชมนี้',
    confirm_booking: 'ยืนยันการจอง',
    slot_filled: 'ช่วงเวลานี้ถูกจองไปแล้ว กรุณาเลือกเวลาอื่น',
    book_error: 'ไม่สามารถยืนยันการจองได้ กรุณาลองอีกครั้ง',
    context_lost: 'กรุณาเริ่มใหม่และเลือกช่วงเวลา',
    confirmed_title: 'ยืนยันการจองแล้ว',
    confirmed_message: 'พบกันที่ {{property}} เร็ว ๆ นี้',
    book_another: 'จองการเข้าเยี่ยมชมอีกครั้ง',
  },
  dashboard_strip: {
    title: 'วันนี้',
    view_all: 'ดูการมาถึงทั้งหมด',
    staff_on_shift: 'เจ้าหน้าที่เข้าเวร: {{count}}',
    visitors_today: 'ผู้มาเยือนวันนี้: {{count}}',
    not_yet_arrived: 'ยังมาไม่ถึง: {{count}}',
  },
  arrivals: {
    title: 'การมาถึงของผู้มาเยือน',
    subtitle: 'ผู้มาเยือนที่คาดไว้และวอล์กอินของวันนี้',
    empty: 'ไม่มีการมาถึงที่กำหนดไว้สำหรับวันนี้',
    load_error: 'ไม่สามารถโหลดการมาถึงของวันนี้ได้ กรุณาลองอีกครั้ง',
    status: {
      booked: 'จองแล้ว',
      arrived: 'มาถึงแล้ว',
      departed: 'ออกไปแล้ว',
      cancelled: 'ยกเลิก',
      no_show: 'ไม่มา',
    },
    actions: {
      check_in: 'มาถึง',
      check_out: 'ออกไป',
      cancel: 'ยกเลิก',
    },
  },
}
